import { IBestbets } from './IBestbets';
import { bestbetsProperties } from './mapperConfig';
import { UtilityService } from '../../../infrastructure/services/utils';

/**
 * provide transformation functionality for bestbets data using mapper configuration
 * @param   {Object} bestbetsItem transformed object
 */
export class BestbetsMapper {
  bestbetsUser: IBestbets = {};

  constructor(bestbetsProperty: [] = []) {
    this.bestbetsUser = UtilityService.getMappedProperties(
      bestbetsProperty,
      bestbetsProperties,
      this.bestbetsUser
    );
  }
}
